















































import { isViewAsSelected } from "@/store/modules/TargetUserModule";
import { Component, Vue, Ref } from "vue-property-decorator";
import { Mailbox } from "@/data/models/Mailbox";
import { observeMailboxesOfClient } from "@/data/repository/MailboxRepository";
import { getUserDisplayName } from "@/utils/UserUtils";
import { findUser } from "@/data/repository/UserRepository";
import { joinToString } from "@/utils/LocalisationHelper";
import MailboxFormComponent from "./MailboxForm.vue";
import { ToolbarContentModule } from "@/store/modules/ToolbarContent";
import { COLOR_TABLE_HEADER, COLOR_TABLE_HEADER_DARK } from "@/utils/colors";
import { themed } from "@/utils/Theme";

@Component({
  components: {
    "mailbox-form": MailboxFormComponent,
  },
})
export default class MailboxListComponent extends Vue {
  /** Nothing may be changed while "Sicht auf" is active (ticket 2610051). */
  get isViewAsReadOnly() {
    return isViewAsSelected();
  }

  @Ref("mailboxForm")
  mailboxFormComponent!: MailboxFormComponent;

  subscriptions: Array<() => void> = [];

  mailboxes: Mailbox[] = [];

  /** Table header background, theme-aware so it stays readable in dark mode. */
  get tableHeaderColor() {
    return themed(COLOR_TABLE_HEADER, COLOR_TABLE_HEADER_DARK);
  }

  formatUserNames(userIds: string[]) {
    return joinToString(
      userIds.map((userId) => getUserDisplayName(findUser(userId))),
      ", "
    );
  }

  formatMailboxSortValue(mailbox: Mailbox) {
    return mailbox.sortValue ?? 1;
  }

  async onCreateMailBox() {
    await this.mailboxFormComponent.show();
  }

  async onEditMailbox(mailbox: Mailbox) {
    await this.mailboxFormComponent.show(mailbox);
  }

  mounted() {
    this.setToolbarTitle();

    this.subscriptions.push(
      observeMailboxesOfClient((mailboxes: Mailbox[]) => {
        this.mailboxes = mailboxes.sort(
          (a, b) => (a.sortValue ?? 1) - (b.sortValue ?? 1)
        );
      })
    );
  }

  beforeDestroy() {
    this.subscriptions.forEach((subscription) => {
      subscription();
    });
  }

  setToolbarTitle() {
    const baseTitle = this.$t("pages.settings").toString();
    const currentPageTitle = this.$t("settings.mailboxes").toString();

    const toolbarTitle = baseTitle + " > " + currentPageTitle;

    ToolbarContentModule.setToolbarTitle(toolbarTitle);
  }
}
